/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner } from './CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner';
import {
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSONTyped,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerToJSON,
} from './CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner';

/**
 * 
 * @export
 * @interface CustomComponentLibrariesLibraryIdRevisionsGet200Response
 */
export interface CustomComponentLibrariesLibraryIdRevisionsGet200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200Response
     */
    success: boolean;
    /**
     * An array of requested items
     * @type {Array<CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner>}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200Response
     */
    data: Array<CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner>;
    /**
     * Total number of items in the response
     * @type {number}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200Response
     */
    totalCount: number;
    /**
     * A token to retrieve the next page of items in the collection
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200Response
     */
    nextToken: string | null;
    /**
     * Whether there are more items in the collection
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdRevisionsGet200Response interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdRevisionsGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "nextToken" in value;
    isInstance = isInstance && "hasMore" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseFromJSON(json: any): CustomComponentLibrariesLibraryIdRevisionsGet200Response {
    return CustomComponentLibrariesLibraryIdRevisionsGet200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdRevisionsGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': ((json['data'] as Array<any>).map(CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSON)),
        'totalCount': json['total_count'],
        'nextToken': json['next_token'],
        'hasMore': json['has_more'],
    };
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseToJSON(value?: CustomComponentLibrariesLibraryIdRevisionsGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': ((value.data as Array<any>).map(CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerToJSON)),
        'total_count': value.totalCount,
        'next_token': value.nextToken,
        'has_more': value.hasMore,
    };
}

